import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { HeaderCell } from 'common/src/designSystem/components/table/headerCell';
import { HeaderRow } from 'common/src/designSystem/components/table/headerRow';
import { Table } from 'common/src/designSystem/components/table/table';
import { UserProfileAccreditationsQuery } from 'common/src/generated/types';
import { sortBy } from 'lodash-es';
import { DateTime } from 'luxon';
import * as React from 'react';
import { UserAccreditationsAssignedListRow } from './userAccreditationsAssignedListRow';

interface IUserAccreditationsAssignedListProps {
    event: UserProfileAccreditationsQuery['event'];
    selectedDay: DateTime | null;

    reload(): void;
}

export const UserAccreditationsAssignedList = (props: IUserAccreditationsAssignedListProps) => {
    const { translate } = useHeavent();
    const auis = React.useMemo(
        () =>
            sortBy(
                props.event.volunteerRegistration.accreditationsUsersInfos.filter((aui) => {
                    if (props.selectedDay?.isValid) {
                        if (aui.accreditationSlot.date?.isValid) {
                            return (
                                aui.accreditationSlot.date.startOf('day').toMillis() ===
                                props.selectedDay.startOf('day').toMillis()
                            );
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                }),
                (aui) => [
                    aui.accreditationCategory.name.toLowerCase(),
                    aui.accreditation.name.toLowerCase(),
                    aui.accreditationSlot.date?.toMillis() ?? 1,
                    aui.accreditationSlot.name.toLowerCase()
                ]
            ),
        [props.event, props.selectedDay]
    );

    return (
        <Table css={{ borderTop: '1px solid $gray200' }} hideBorder={true}>
            <HeaderRow>
                <HeaderCell>{translate('Accreditation')}</HeaderCell>
                <HeaderCell>{translate('affect_e_automa_74071')}</HeaderCell>
                <HeaderCell>{translate('ajout_e_le_54957')}</HeaderCell>
                <HeaderCell>{translate('ajout_e_par_71330')}</HeaderCell>
                <HeaderCell>{translate('ajout_via_une_69544')}</HeaderCell>
                {props.event.isWeezeventConnected && (
                    <HeaderCell>{translate('scann_e_le_27812')}</HeaderCell>
                )}
                <HeaderCell width={100} />
            </HeaderRow>

            {auis.map((aui) => (
                <UserAccreditationsAssignedListRow
                    key={aui.id}
                    aui={aui}
                    isWeezeventConnected={props.event.isWeezeventConnected}
                    reload={props.reload}
                />
            ))}
        </Table>
    );
};
